import {
  ModalConfirmDeleteProps,
  typeConfirmDelete
} from "@saleor/changeOrderDomestic/views/ViewEditOrder/types";
import { useState } from "react";
import { useIntl } from "react-intl";

interface Props {
  setOpenModalConfirmDelete: React.Dispatch<React.SetStateAction<boolean>>;
}

function useCancelOrder({ setOpenModalConfirmDelete }: Props) {
  const intl = useIntl();
  const [dataModalConfirmDelete, setDataModalConfirmDelete] = useState<
    ModalConfirmDeleteProps
  >({});
  const handleCancelOrder = () => {
    setDataModalConfirmDelete({
      title: intl.formatMessage({ defaultMessage: "ยกเลิกคำสั่งซื้อ !" }),
      content: intl.formatMessage({
        defaultMessage:
          "กรุณากด “ยืนยัน” เพื่อยกเลิกคำสั่งซื้อนี้ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้"
      }),
      cancelText: intl.formatMessage({ defaultMessage: "กลับไป" }),
      okText: intl.formatMessage({ defaultMessage: "ยืนยัน" }),
      typeConfirm: typeConfirmDelete.cancelOrder
    });
    setOpenModalConfirmDelete(true);
  };
  return { handleCancelOrder, dataModalConfirmDelete };
}

export default useCancelOrder;
